import React, { useEffect, useState } from "react";

const slidesData = [
  {
    backgroundDesktop: "./banner/Banner1.webp",
    backgroundMobile: "./banner/mobile_banner1.webp",
    topTitle: "Productivity Starts With Purity",
    bottomTitle:
      "Engineered air purification solutions to support workplace health and peak performance",
  },
  {
    backgroundDesktop: "./banner/Banner3.webp",
    backgroundMobile: "./banner/mobile_banner3.webp",
    topTitle: "Protecting Every Breath In Critical Spaces",
    bottomTitle:
      "Engineered air systems for high risk zones across hospitals and medical facilities",
  },
  {
    backgroundDesktop: "./banner/Banner4.webp",
    backgroundMobile: "./banner/mobile_banner4.webp",
    topTitle: "Pure Comfort Begins With Pure Air",
    bottomTitle:
      "Enhance guest Experience with silent efficient air purification in every room",
  },
  {
    backgroundDesktop: "./banner/Banner2.webp",
    backgroundMobile: "./banner/mobile_banner2.webp",
    topTitle: "Engineered For Moment. Build For Protection",
    bottomTitle:
      "Custom air purification systems build to serve the dynamic needs of modern airports",
  },
];

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // adjust breakpoint as needed
    };

    handleResize(); // set on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slidesData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">
      {slidesData.map((slide, i) => (
        <div
          key={i}
          className={`slide ${i === index ? "active" : ""}`}
          style={{
            backgroundImage: `url(${
              isMobile ? slide.backgroundMobile : slide.backgroundDesktop
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "opacity 0.5s ease-in-out",
          }}
        ></div>
      ))}

      <div className="overlay"></div>

      <div className="content">
        <h2 className="slide-up Carousel_heading">
          {slidesData[index].topTitle}
        </h2>
        <h2 id="title" className="slide-up carousel_subHeading">
          {slidesData[index].bottomTitle}
        </h2>
      </div>
    </div>
  );
};

export default HeroCarousel;
